var _g, _path, _path2, _circle, _path3, _path4, _path5, _g2, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyJourney = function SvgEmptyJourney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 198 54"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8FA",
    fillRule: "evenodd",
    d: "M56 8.333H21c-1.375 0-2.5 1.072-2.5 2.381v28.572c0 1.31 1.125 2.38 2.5 2.38h35c1.375 0 2.5-1.07 2.5-2.38V10.714c0-1.31-1.125-2.38-2.5-2.38",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACB5C2",
    d: "M18.5 13h40v1.333h-40z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.833,
    cy: 10.667,
    r: 1,
    fill: "#ACB5C2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACB5C2",
    fillRule: "evenodd",
    d: "M24.167 9.667c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1M27.5 11.667c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1M45.167 18.333v13.334H54.5V18.333z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "M21.5 18.333v20h20v-20z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E7EC",
    fillRule: "evenodd",
    d: "M124.75 0h-52.5c-2.062 0-3.75 1.607-3.75 3.571V46.43c0 1.964 1.688 3.571 3.75 3.571h52.5c2.062 0 3.75-1.607 3.75-3.571V3.57c0-1.964-1.688-3.571-3.75-3.571",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACB5C2",
    d: "M68.5 7h60v2h-60z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 3.5,
    r: 1.5,
    fill: "#ACB5C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACB5C2",
    fillRule: "evenodd",
    d: "M77 2c-.9 0-1.5.6-1.5 1.5S76.1 5 77 5s1.5-.6 1.5-1.5S77.9 2 77 2M82 5c.9 0 1.5-.6 1.5-1.5S82.9 2 82 2s-1.5.6-1.5 1.5S81.1 5 82 5",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#748499",
    fillRule: "evenodd",
    d: "M108.5 15v20h14V15z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACB5C2",
    fillRule: "evenodd",
    d: "M73 15v30h30V15z",
    clipRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8FA",
    fillRule: "evenodd",
    d: "M166.625 12.5h-26.25c-1.031 0-1.875.804-1.875 1.786v21.428c0 .982.844 1.786 1.875 1.786h26.25c1.031 0 1.875-.804 1.875-1.786V14.286c0-.982-.844-1.786-1.875-1.786",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACB5C2",
    d: "M138.5 16h30v1h-30z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.25,
    cy: 14.25,
    r: 0.75,
    fill: "#ACB5C2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACB5C2",
    fillRule: "evenodd",
    d: "M142.75 13.5c-.45 0-.75.3-.75.75s.3.75.75.75.75-.3.75-.75-.3-.75-.75-.75M145.25 15c.45 0 .75-.3.75-.75s-.3-.75-.75-.75-.75.3-.75.75.3.75.75.75M158.5 20v10h7V20z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "M140.75 20v15h15V20z",
    clipRule: "evenodd"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52,
    r: 2,
    fill: "#E4E7EC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 41.5,
    r: 1.5,
    fill: "#E4E7EC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 41.5,
    r: 1.5,
    fill: "#E4E7EC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 46,
    r: 1,
    fill: "#ACB5C2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 45,
    r: 1,
    fill: "#D4DAE1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 50,
    r: 1,
    fill: "#748499"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 47,
    r: 1,
    fill: "#ACB5C2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 40,
    r: 2,
    fill: "#E4E7EC",
    transform: "rotate(180 145.5 40)"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 50.5,
    r: 1.5,
    fill: "#E4E7EC",
    transform: "rotate(180 136 50.5)"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 50.5,
    r: 1.5,
    fill: "#E4E7EC",
    transform: "rotate(180 186 50.5)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 46,
    r: 1,
    fill: "#ACB5C2",
    transform: "rotate(180 156.5 46)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 47,
    r: 1,
    fill: "#D4DAE1",
    transform: "rotate(180 179.5 47)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.5,
    cy: 42,
    r: 1,
    fill: "#748499",
    transform: "rotate(180 166.5 42)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.5,
    cy: 45,
    r: 1,
    fill: "#ACB5C2",
    transform: "rotate(180 196.5 45)"
  })));
};
export { SvgEmptyJourney as ReactComponent };
export default __webpack_public_path__ + "fonts/empty-journey-0142fdde4adfa93b59acb7b04c9338b0.svg";